import React from 'react';
import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import { theme } from '../../theme/theme';

export function Text(props: ChakraTextProps) {
  return <ChakraText color={theme.colors.primary['1000']} {...props} />;
}
